import { Directory } from "../../../../../domain/drawing";

/**
 * TODO: components/settings/dialogsにほぼ同じ処理があるのでどこかのタイミングで統一したほうが良い
 */
export class FormatReferenceTreeAddFormatTreeDialogModel<T> {
  constructor() {
    this.selectedDirectory = null;
    this.selectedFormats = null;
    this.selectedOfAllFormats = null;
  }
  selectedDirectory: Directory<string, T>;
  selectedFormats: T[];
  selectedOfAllFormats: T[];
}
